<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Roles list </h4>
                <p class="text-subtitle-1">list of roles</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn color="primary" block @click="handleNew"
                    v-if="hasPermission(permissions.role.create)"
                >
                    <v-icon left>mdi-plus</v-icon>
                    create role
                </v-btn>    
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="4" >
                <v-text-field
                    label="Search" 
                    outlined
                    rounded
                    dense
                    hide-details="auto"
                    append-icon="mdi-magnify"
                    v-model="search.name"
                    @input="searchByName"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    :headers="headers"
                    :items="data"
                    :loading="loading"
                    :page.sync="page"
                    :server-items-length="serverItemsLength"
                    :options.sync="options"
                    dense
                >
                <template v-slot:[`item.name`]="{ item }">
                    <v-btn icon @click="handle(item.id)"
                        v-if="hasPermission(permissions.role.read)"
                    >
                        <v-icon>
                            mdi-magnify
                        </v-icon>
                    </v-btn>
                    {{ item.name}}
                </template>
                <template v-slot:[`item.inactive`]="{ item }">
                    <v-icon :color="item.inactive ? 'error' : 'success'">
                        {{ item.inactive ? 'mdi-window-close' : 'mdi-check-all'}}
                    </v-icon>
                </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import permissions from "../../data/permissions" ;
import authorize from '../../utils/authorize';
import role from "./../../services/administration/role"
export default {
    data() {
        return {
            headers: [
                {text: "Role Name", value: "name"},
                {text: "Is Active", value: "inactive"}
            ],
            data: [],
            search: {},
            options: {},
            serverItemsLength: 0,
            page: 1,
            loading: false,
            permissions
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetchRoles();
            }
        }
    },
    methods: {
        fetchRoles() {
            this.loading = true
            role.list({...this.options, ...this.search}).then(response => {
                this.data = response.data.data
                this.serverItemsLength = response.data.total
            }).finally(() => {
                this.loading = false
            })
        },
        handle(id) {
            this.$router.push({ name: "RoleDisplay", params: { id } })
        },
        handleNew() {
            this.$router.push({name: "Role"})
        },
        searchByName() {
            this.page = 1;
            this.fetchRoles();
        },
        hasPermission(permission) {
            return authorize(permission)
        }
    }
}
</script>

<style>

</style>